var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.chip ? _c('span', [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.USER,
      "field": _vm.partnerId
    }
  }, _vm._l(_vm.first, function (assignee, index) {
    return _c('tooltip', {
      key: 'assignee' + assignee ? assignee.id : index,
      attrs: {
        "text": assignee.userName
      }
    }, [_c('v-chip', {
      staticStyle: {
        "max-width": "130px"
      },
      attrs: {
        "color": "grey lighten-2 ",
        "small": ""
      }
    }, [_c('span', {
      staticClass: "text-truncate",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.getAssigneeName(assignee)) + " ")])])], 1);
  }), 1), _vm.remaining.length ? _c('tooltip', {
    attrs: {
      "text": _vm.remaining.map(function (assignee) {
        return _vm.getAssigneeName(assignee);
      }).join('<br/>')
    }
  }, [_c('v-chip', {
    staticClass: "ml-1 pa-1",
    attrs: {
      "color": "grey",
      "small": "",
      "outlined": ""
    }
  }, [_vm._v(" +" + _vm._s(_vm.remaining.length) + " ")])], 1) : _vm._e()], 1) : _c('span', [_vm._l(_vm.first, function (assignee, index) {
    return _c('Can', {
      key: 'assignee' + assignee ? assignee.id : index,
      attrs: {
        "I": _vm.ActionEnum.READ,
        "a": _vm.ResourceEnum.USER,
        "field": _vm.partnerId
      }
    }, [assignee && assignee.firstName && assignee.lastName ? _c('tooltip', {
      attrs: {
        "text": _vm.getAssigneeName(assignee)
      }
    }, [_c('v-avatar', {
      class: index !== _vm.assignees.length - 1 || _vm.remaining.length ? 'mr-n1' : '',
      attrs: {
        "color": "grey lighten-2",
        "size": _vm.small ? '24px' : '32px'
      }
    }, [_vm.small ? _c('small', [_vm._v(" " + _vm._s(_vm.getAssigneeInititals(assignee)) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.getAssigneeInititals(assignee)) + " ")])])], 1) : _vm._e()], 1);
  }), _vm.remaining.length ? _c('tooltip', {
    attrs: {
      "text": _vm.remaining.map(function (assignee) {
        return _vm.getAssigneeName(assignee);
      }).join('<br/>')
    }
  }, [_c('v-avatar', {
    staticClass: "ml-n1",
    attrs: {
      "color": "grey lighten-2",
      "size": _vm.small ? '24px' : '32px'
    }
  }, [_vm.small ? _c('small', [_vm._v("+" + _vm._s(_vm.remaining.length) + " ")]) : _c('span', [_vm._v(" +" + _vm._s(_vm.remaining.length) + " ")])])], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }